import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

type ILoaderState = {
  route: string;
  isLoading: boolean;
  type: 'spinner' | 'skeleton' | 'button';
};

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private subject: BehaviorSubject<ILoaderState> = new BehaviorSubject({
    route: '',
    isLoading: false,
    type: 'spinner',
  });

  public _observer: Observable<ILoaderState> = this.subject.asObservable();

  constructor() {}

  showLoader(payload: Omit<ILoaderState, 'isLoading'>) {
    this.subject.next({ ...payload, isLoading: true });
  }

  hideLoader(payload: Omit<ILoaderState, 'isLoading'>) {
    this.subject.next({ ...payload, isLoading: false });
  }
}
